import React, { useEffect } from "react";
import useClientMetrics from "../../../../../../../hooks/useClientMetrics.js";
import useFareRulesInfoWithPartialsController from "./useFareRulesInfoWithPartials.controller.js";
import useProfiler from "../../../../../../../hooks/useProfiler.js";
import { Icon, Stack, Text } from "@bookingcom/bui-react";
import FareRulesInfoWithPartialsMobile from "./FareRulesInfoWithPartials.mobile.js";
import { track } from "@flights/et-universal";
import FareRulesInfoWithPartialsDesktop from "./FareRulesInfoWithPartials.desktop.js";
const useFareRulesInfoWithPartials = (flight) => {
    const data = useFareRulesInfoWithPartialsController(flight);
    const { header, subheader, hasFareRules, fareRules, disclaimer } = data;
    const { trackClientMetric } = useClientMetrics();
    useEffect(() => {
        if (!hasFareRules)
            return undefined;
        trackClientMetric("fare_rules_available_on_flight_details");
    }, [hasFareRules, trackClientMetric]);
    const { isMobile, isDesktop } = useProfiler();
    if (!hasFareRules)
        return undefined;
    return {
        header,
        subheader,
        content: isDesktop() && !!track("flights_funnel_new_fd_page_desktop") ? (FareRulesInfoWithPartialsDesktop({ ...data })) : isMobile() && !!track("flights_funnel_new_fd_page_mobile") ? (FareRulesInfoWithPartialsMobile({ ...data })) : (React.createElement(Stack, { gap: 2 },
            fareRules?.map((f) => {
                return (React.createElement(Stack.Item, { key: f.featureName },
                    React.createElement(Stack, { direction: "row", gap: 4 },
                        React.createElement(Stack.Item, null,
                            React.createElement(Icon, { size: "large", svg: f.icon })),
                        React.createElement(Stack.Item, { grow: true, alignSelf: "center" },
                            React.createElement(Text, null, f.label)))));
            }),
            disclaimer && React.createElement(Text, { variant: "small_1" }, disclaimer)))
    };
};
export default useFareRulesInfoWithPartials;
